import React from 'react'
import PalexLogo from '../header/PalexLogoNegro'

export const Footer = () => {
  return (
    <footer className='footer' style={{ paddingTop: '1rem'}}>
      {/* Primera sección - Fondo teal con iconos sociales, links legales y disclaimer */}
      <div className='footer__section-main'>
        {/* Social Media Icons */}
        <div className='footer__social'>
          <a
            href='https://www.youtube.com/@Palex-Espana'
            target='_blank'
            rel='noopener noreferrer'
            className='footer__social-link'
          >
            <img
              src='https://hbcpnyhdzrfbozosmtwk.supabase.co/storage/v1/object/public/footer-images/17-1-2025-10:23:03-1737105783952-'
              alt='YouTube'
            />
          </a>
          <a
            href='https://www.linkedin.com/company/palex-espana/'
            target='_blank'
            rel='noopener noreferrer'
            className='footer__social-link'
          >
            <img
              src='https://hbcpnyhdzrfbozosmtwk.supabase.co/storage/v1/object/public/footer-images/20-3-2025-13:06:06-1742472366259-palex-linkedin.svg'
              alt='LinkedIn'
            />
          </a>
        </div>

        {/* Legal Links */}
        <div className='footer__legal'>
          <a
            href='https://www.palexhealth.com/es-es/legal'
            target='_blank'
            rel='noopener noreferrer'
            className='footer__legal-link'
          >
            Aviso legal
          </a>
          <span className='footer__legal-separator'>|</span>
          <a
            href='https://www.palexhealth.com/es-es/privacy'
            target='_blank'
            rel='noopener noreferrer'
            className='footer__legal-link'
          >
            Política de privacidad
          </a>
          <span className='footer__legal-separator'>|</span>
          <a
            href='https://www.palexhealth.com/es-es/privacy-rrss'
            target='_blank'
            rel='noopener noreferrer'
            className='footer__legal-link'
          >
            Política de privacidad RRSS
          </a>
          <span className='footer__legal-separator'>|</span>
          <a
            href='https://www.palexhealth.com/es-es/cookies'
            target='_blank'
            rel='noopener noreferrer'
            className='footer__legal-link'
          >
            Política de cookies
          </a>
          <span className='footer__legal-separator'>|</span>
          <a
            href='https://www.palexhealth.com/es-es/contact'
            target='_blank'
            rel='noopener noreferrer'
            className='footer__legal-link'
          >
            Contacto
          </a>
          <span className='footer__legal-separator'>|</span>
          <a
            href='https://www.palexhealth.com/es-es/internal-information-system'
            target='_blank'
            rel='noopener noreferrer'
            className='footer__legal-link'
          >
            Internal Information System
          </a>
        </div>

        {/* Disclaimer */}
        <p className='footer__disclaimer'>
          Toda la información contenida y mostrada en este sitio web va dirigida
          exclusivamente a profesionales sanitarios.
        </p>
      </div>

      {/* Segunda sección - Sin fondo, solo logo y copyright */}
      <div className='footer__section-bottom'>
        <div className='footer__copyright-logo'>
          <PalexLogo />
        </div>
        <p className='footer__copyright-text'>
          Copyright ©Palex. Todos los derechos reservados
        </p>
      </div>
    </footer>
  )
}
